export const AdminDashboardCardsData = [
  {
    title: "Forms!",
    description:
      "Any form displayed in the UI can be dynamically generated by passing a JSON structure, making it easy to implement and maintain.",
    navigationLink: "/admin/forms",
    iconColor: "#9333ea",
    iconBgColor: "#f3e8ff",
  },
  {
    title: "Lookup",
    description: "Values for any dropdown can be easily added.",
    navigationLink: "/admin/lookup",
    iconColor: "#2563eb",
    iconBgColor: "#dbeafe",
  },
  {
    title: "UI Configuration",
    description:
      "Manage your login page by switching between images or videos as the login banner. You can also modify the app logo, loader, and app theme from this section.",
    navigationLink: "/admin/uiconfiguration",
    iconColor: "#e11d48",
    iconBgColor: "#ffe4e6",
  },
  {
    title: "Features",
    description:
      "Enable or disable features to manage their availability in the portal.",
    navigationLink: "/admin/features",
    iconColor: "#4f46e5",
    iconBgColor: "#e0e7ff",
  },
  {
    title: "Secret Keys",
    description: "Manage all your secret keys by adding or removing them.",
    navigationLink: "/admin/secretkeys",
    iconColor: "#d97706",
    iconBgColor: "#fef3c7",
  },
  {
    title: "User Management",
    description: "Manage the permissions and access rights of admin users.",
    navigationLink: "/admin/usermanagement",
    iconColor: "#16a34a",
    iconBgColor: "#dcfce7",
  },
  {
    title: "Login Reports",
    description:
      "View detailed login activity and reports for all users, including login/logout events, device types, user types (customer, agent, admin), and more, with data visualizations.",
    navigationLink: "/admin/loginreports",
    iconColor: "#e11d48",
    iconBgColor: "#ffe4e6",
  },
  {
    title: "Content Management",
    description:
      "Create, manage, and publish custom content including articles, blogs, and alert banners and can also set publication dates, all from a single dashboard.",
    navigationLink: "/admin/cms",
    iconColor: "#9333ea",
    iconBgColor: "#f3e8ff",
  },
  {
    title: "Conversation Analysis",
    description:
      "View and analyze the tone of Insure Assist conversations through sentiment analysis.",
    navigationLink: "/admin/conversation-analysis",
    iconColor: "#d97706",
    iconBgColor: "#fef3c7",
  },
  {
    title: "Insure Assist Performance",
    description:
      "Know the maximum latency spent and tokens used for Insure Assist Conversations.",
    navigationLink: "/admin/insure-assist-performance",
    iconColor: "#16a34a",
    iconBgColor: "#dcfce7",
  },
  {
    title: "Communication Templates",
    description: "Manage email templates for customer communications.",
    navigationLink: "/admin/communication-templates",
    iconColor: "#9333ea",
    iconBgColor: "#f3e8ff",
  },
  {
    title: "Prompt Management",
    description: "Manage prompts associated with Insure Assist conversations.",
    navigationLink: "/admin/prompt-management",
    iconColor: "#16a34a",
    iconBgColor: "#dcfce7",
  },
  {
    title: "Password Rules Configuration",
    description:
      "Allows Super Admins to define and manage password complexity rules.",
    navigationLink: "/admin/password-configuration",
    iconColor: "#e11d48",
    iconBgColor: "#ffe4e6",
  },
  {
    title: "Roles & Permissions",
    description:
      "Define and manage user roles and access permissions to ensure secure and appropriate feature access within the system.",
    navigationLink: "/admin/roles-permissions",
    iconColor: "#d97706",
    iconBgColor: "#fef3c7",
  },
  {
    title: "Customer Activity Analytics",
    description:
      "Track and quantify user-initiated sessions related to Claims and Policy Change Requests.",
    navigationLink: "/admin/customer-analytics",
    iconColor: "#4f46e5",
    iconBgColor: "#e0e7ff",
  },
];

export const groupedModules = [
  {
    title: "Reports",
    items: [
      "Login Reports",
      "Conversation Analysis",
      "Insure Assist Performance",
      "Customer Activity Analytics",
    ],
  },
  {
    title: "UX Configs",
    items: [
      "Forms!",
      "Lookup",
      "UI Configuration",
      "Content Management",
      "Communication Templates",
    ],
  },
  {
    title: "Feature Configurations",
    items: [
      "Features",
      "Secret Keys",
      "User Management",
      "Prompt Management",
      "Password Rules Configuration",
      "Roles & Permissions",
    ],
  },
];

export const getBreadcrumbName = (route: string) => {
    // Custom mapping for known routes
    switch (route.toLowerCase()) {
      case "dashboard":
        return "Dashboard";
      case "forms":
        return "Forms";
      case "lookup":
        return "Lookup";
      case "uiconfiguration":
        return "UI Configuration";
      case "features":
        return "Features";
      case "secretkeys":
        return "Secret Keys";
      case "usermanagement":
        return "User Management";
      case "settings":
        return "Settings";
      case "loginreports":
        return "Login Reports";
      case "cms":
        return "Content Management";
      case "conversation-analysis":
        return "Conversation Analysis";
      case "insure-assist-performance":
        return "Insure Assist Performance";
      case "communication-templates":
        return "Communication Templates";
      case "prompt-management":
        return "Prompt Management";
      case "password-configuration":
        return "Password Rules Configuration";
      case "roles-permissions":
        return "Roles & Permissions";
      case "customer-analytics":
        return "Customer Activity Analytics";
      default:
        return (
          route
            .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
            .replace(/[_\-]+/g, " ")
            .replace(
              /\w\S*/g,
              (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            )
        );
    }
  };